export const cityData = [
  {
    key: "1",
    CITYNAME: "Los Angles",
    IMAGE: "us.png",
    STATENAME: "California",
    CREATEDDATE: "United States",
    STATUS: "Active",
  },
  {
    key: "2",
    CITYNAME: "New York City",
    IMAGE: "us.png",
    STATENAME: "New York",
    CREATEDDATE: "United States",
    STATUS: "Inactive",
  },
  {
    key: "3",
    CITYNAME: "Houston",
    IMAGE: "us.png",
    STATENAME: "Texas",
    CREATEDDATE: "United States",
    STATUS: "Active",
  },
  {
    key: "4",
    CITYNAME: "Munich",
    IMAGE: "de.png",
    STATENAME: "Baveria",
    CREATEDDATE: "Germany",
    STATUS: "Active",
  },
  {
    key: "5",
    CITYNAME: "Montreal",
    IMAGE: "ca.png",
    STATENAME: "Quebec",
    CREATEDDATE: "Canada",
    STATUS: "Active",
  },
  {
    key: "6",
    CITYNAME: "Toronto",
    IMAGE: "ca.png",
    STATENAME: "Ontario",
    CREATEDDATE: "Canada",
    STATUS: "Inactive",
  },
  {
    key: "7",
    CITYNAME: "Miami",
    IMAGE: "us.png",
    STATENAME: "Florida",
    CREATEDDATE: "United States",
    STATUS: "Inactive",
  },
  {
    key: "8",
    CITYNAME: "Calgary",
    IMAGE: "de.png",
    STATENAME: "Berlin",
    CREATEDDATE: "Germany",
    STATUS: "Active",
  },
  {
    key: "9",
    CITYNAME: "Melbourne",
    IMAGE: "au.png",
    STATENAME: "Victoria",
    CREATEDDATE: "Australia",
    STATUS: "Active",
  },
  {
    key: "10",
    CITYNAME: "Johannesburg",
    IMAGE: "eg.png",
    STATENAME: "Gauteng",
    CREATEDDATE: "Egypt",
    STATUS: "Active",
  },
];
